import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/svg/premium-proxies.svg'
import _imports_1 from '@/assets/img/svg/dedicated-proxy.svg'


const _withScopeId = n => (_pushScopeId("data-v-0895708e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"jumbotron\" data-v-0895708e><div class=\"container\" data-v-0895708e><div class=\"row\" data-v-0895708e><div class=\"col-12 col-md-8 infotext\" data-v-0895708e><div class=\"text\" data-v-0895708e><div class=\"row\" data-v-0895708e><div class=\"col-12\" data-v-0895708e><h1 data-v-0895708e>High-performance &amp; Affordable<br data-v-0895708e>Socks4 Proxy Servers</h1></div></div><ul data-v-0895708e><li data-v-0895708e>Up to 40 000 Socks4 datacenter proxies</li><li data-v-0895708e>99% uptime guarantee</li><li data-v-0895708e>Unlimited bandwidth</li></ul><div class=\"row\" data-v-0895708e><div class=\"col-lg-5 col-12\" data-v-0895708e><a class=\"btn w-100\" href=\"/premium?ref=buy-Socks4-proxy\" data-v-0895708e>Premium proxies</a></div><div class=\"col-lg-5 col-12\" data-v-0895708e><a class=\"btn-outline-jum w-100\" href=\"#services\" data-v-0895708e>Other Socks4 services</a></div></div></div></div></div></div></div>", 1)
const _hoisted_2 = { class: "bottomjumbo" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "section-title services",
    id: "services"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Our services that support Socks4"),
    /*#__PURE__*/_createElementVNode("p", null, "for your proxy needs")
  ])
], -1))
const _hoisted_6 = { class: "row services" }
const _hoisted_7 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_8 = { class: "itemcard downloadcard" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "premium proxies",
  src: _imports_0
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "helperbird-editor medium-editor-element" }, "Premium proxies", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " High-performance shared Socks4 proxies at a fraction of the cost of dedicated proxies with unlimited bandwidth. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downloadbtn" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/premium?ref=buy-Socks4-proxy" }, "Tell Me More")
], -1))
const _hoisted_13 = { class: "col-lg-6 col-md-6 col-12" }
const _hoisted_14 = { class: "itemcard downloadcard" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "helperbird-editor medium-editor-element" }, "Dedicated proxies", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Dedicated Socks4 proxies with a speed of up to 1Gbps and unlimited bandwidth only used by you! ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "downloadbtn" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/dedicated-proxies?ref=buy-Socks4-proxy",
    style: {},
    target: "_blank"
  }, "Get dedicated proxies")
], -1))
const _hoisted_19 = { class: "row serviceusecases" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title services" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Our proxy services"),
    /*#__PURE__*/_createElementVNode("p", null, "for all your needs")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn",
    href: "#services"
  }, "Start now")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "section-title services clients" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "What our clients say"),
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://cdn.proxyscrape.com/img/section-shape.png",
      alt: "section-shape"
    })
  ])
], -1))

import ServicesDetail from '../shared/ServicesDetail.vue';
import UseCases from '../shared/UseCases.vue';
import ClientReviews from '../shared/ClientReviews.vue';
import BannerSection from '../shared/BannerSection.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/premium?ref=home" }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _hoisted_11,
                _hoisted_12
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_router_link, { to: "/dedicated?ref=home" }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _hoisted_17,
                _hoisted_18
              ])
            ])
          ]),
          _createVNode(ServicesDetail),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(UseCases),
            _hoisted_21
          ]),
          _hoisted_22,
          _createVNode(ClientReviews),
          _createVNode(BannerSection)
        ])
      ])
    ])
  ]))
}
}

})